import { IconStopwatch } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

import { InsightsDetails } from '@/pages/BuildDetailsPage/hooks/useInsightsDetails';
import { formatDuration } from '@/utils/commonFormats';

import Clock, { formatClockDuration } from '../Clock/Clock';
import RunnableMeta from './RunnableMeta';

const DurationMeta = ({
  duration,
  insightsDetails,
  previousDuration,
}: {
  duration: { start?: Date; end?: Date } | string;
  insightsDetails?: InsightsDetails;
  previousDuration?: number;
}) => {
  const { start, end } = typeof duration === 'object' ? duration : {};
  const increasedBy = insightsDetails?.duration?.increasedBy;
  // A definition's term is plain text, so a finished build that got slower shows its duration as
  // the text its Clock would; a running build keeps the live Clock.
  const definitionTerm = start && end && increasedBy ? formatClockDuration(start, end) : undefined;
  const durationData = start ? <Clock as="span" startDate={start} endDate={end} /> : undefined;

  const shared = {
    icon: IconStopwatch,
    status: increasedBy ? ('increasing' as const) : undefined,
  };
  const defaultTooltipLabel = (
    <>
      <Text as="span" fontWeight={previousDuration ? '600' : undefined}>
        Duration
      </Text>
      {!!previousDuration && (
        <>
          <br />
          Previous build duration: {formatDuration(previousDuration)}
        </>
      )}
    </>
  );

  if (definitionTerm) {
    return (
      <RunnableMeta
        {...shared}
        data={definitionTerm}
        defaultTooltipLabel={defaultTooltipLabel}
        definitionButton={
          insightsDetails?.duration?.url ? { href: insightsDetails.duration.url, label: 'View trends' } : undefined
        }
        definitionText={`Build duration increased by ${increasedBy}%.${
          previousDuration ? ` Previous build duration: ${formatDuration(previousDuration)}.` : ''
        }`}
      />
    );
  }

  return <RunnableMeta {...shared} data={durationData} defaultTooltipLabel={defaultTooltipLabel} />;
};

export default DurationMeta;
